const RESULTS_VIEW_EVENT = 'cotizador:results-view';

const dispatchResultsView = (detail: Record<string, unknown>): void => {
  document.body.dispatchEvent(new CustomEvent(RESULTS_VIEW_EVENT, { detail }));
};

export const dispatchExpand = (message: string): void => {
  dispatchResultsView({ action: 'expand', message });
};

export const maintainExpandMode = (): void => {
  dispatchExpand('Mantener modo expandido durante acciones de resultados');
};

export const dispatchManualCollapse = (): void => {
  dispatchResultsView({
    action: 'collapse',
    manualClose: true,
    message: 'Cierre manual - regresar al formulario de vehículo',
  });
};
